import { profile } from '../lib/static-data';
import { getBookingHref } from '../lib/cal';
import { SignupForm } from './SignupForm';

export function Contact() {
  return (
    <section
      id="section-contact"
      className="section"
      style={{ padding: '56px 28px 36px', borderBottom: 'none' }}
    >
      <div
        className="grid-contact"
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 48,
          marginBottom: 44,
        }}
      >
        <div>
          <div className="eyebrow" style={{ marginBottom: 16 }}>
            § 05 · Correspond
          </div>
          <div
            className="serif italic contact-headline"
            style={{ fontSize: 'var(--fs-display)', lineHeight: 0.95, letterSpacing: -1.8 }}
          >
            Write me
            <br />a question worth
            <br />
            an answer.
          </div>
          <div
            className="serif italic"
            style={{
              marginTop: 24,
              fontSize: 17,
              maxWidth: 440,
              opacity: 0.82,
            }}
          >
            Best fit: founders 0→1, operators chasing growth, skiers with a
            backcountry opinion, and anyone with a strong take on yakitori, grapefruit, or
            cinnamon.
          </div>
        </div>
        <div style={{ alignSelf: 'end' }}>
          <a
            href={getBookingHref()}
            target="_blank"
            rel="noreferrer"
            style={{
              display: 'block',
              padding: '20px 22px',
              background: 'var(--ink)',
              color: 'var(--paper)',
              textTransform: 'uppercase',
              letterSpacing: 1.8,
              fontWeight: 600,
              fontSize: 13,
              textAlign: 'center',
              marginBottom: 14,
              textDecoration: 'none',
            }}
          >
            ▸ BOOK A MEETING
          </a>
          <div
            style={{
              fontSize: 11,
              opacity: 0.75,
              textAlign: 'center',
              lineHeight: 1.7,
            }}
          >
            or{' '}
            <a
              href={`mailto:${profile.email}`}
              style={{
                borderBottom: '1px solid var(--accent)',
                color: 'var(--accent)',
                textDecoration: 'none',
              }}
            >
              {profile.email}
            </a>
            <br />
            {profile.residences.join(' ✦ ')}
          </div>
        </div>
      </div>

      {/* Newsletter signup — separate row, full width */}
      <div
        style={{
          borderTop: '1px solid var(--ink)',
          paddingTop: 28,
          marginTop: 8,
          display: 'grid',
          gridTemplateColumns: '1fr 1.2fr',
          gap: 32,
          alignItems: 'baseline',
        }}
        className="grid-contact"
      >
        <div>
          <div className="eyebrow-accent" style={{ marginBottom: 8 }}>
            Quarterly dispatch
          </div>
          <div className="serif italic" style={{ fontSize: 22, lineHeight: 1.3 }}>
            New essays in your inbox. About one a month, sometimes less.
          </div>
        </div>
        <div style={{ position: 'relative' }}>
          <SignupForm source="homepage-contact" />
          <div
            style={{
              fontSize: 10,
              textTransform: 'uppercase',
              letterSpacing: 1,
              opacity: 0.5,
              marginTop: 8,
            }}
          >
            One-click unsubscribe in every email. No tracking, no resells.
          </div>
        </div>
      </div>
    </section>
  );
}
